<script lang="ts" setup>
const { template } = storeToRefs(useTemplateStore());

const isLocationOdd = computed(() => {
  return template.value.location.items.length % 2 === 1;
});
</script>

<template>
  <div
    class="px-section py-section-alt text-center flex flex-col items-center gap-10 w-full md:max-w-[calc(var(--breakpoint-sm)-16px)] md:gap-14 lg:gap-16 md:my-16 mdUp:max-w-[calc(var(--breakpoint-md)-16px)] lg:max-w-[calc(var(--breakpoint-mdUp)-62px)] lg:my-[76px] xl:py-20 xl:max-w-[calc(var(--breakpoint-lg)-62px)] 2xl:py-20"
  >
    <div class="flex flex-col gap-4 items-center justify-center">
      <AppSectionTitle
        data-aos="fade-up"
        data-aos-delay="200"
      >
        LOKASI
      </AppSectionTitle>

      <NuxtImg
        src="/line-primary.svg"
        alt="Line Primary"
        data-aos="zoom-in"
        data-aos-delay="400"
        data-aos-duration="700"
        data-aos-anchor="#location"
        class="w-line-graphic"
        loading="lazy"
        decoding="async"
      />
    </div>

    <NuxtImg
      src="location-venues-route.webp"
      alt="Lokasi Venue"
      class="mx-auto w-[80%] h-auto xs:w-full sm:max-w-full sm:w-2xl md:w-4xl"
      decoding="async"
      data-aos="zoom-in-up"
      data-aos-duration="700"
      data-aos-delay="400"
      fetchpriority="high"
      loading="eager"
      :preload="{
        fetchPriority: 'high',
      }"
    />

    <ul
      class="w-full flex flex-col gap-12 lg:grid lg:grid-cols-2 xl:gap-16"
    >
      <li
        v-for="(location, index) in template.location.items"
        :key="location.activity"
        class="flex flex-col gap-6 justify-between md:gap-10"
        :data-aos="index % 2 === 0 ? 'fade-right' : 'fade-left'"
        :data-aos-delay="300 + index * 200"
        :class="{
          'last:lg:col-span-2': isLocationOdd,
        }"
      >
        <div class="flex flex-col gap-4 md:gap-6">
          <h3
            class="text-primary-600 font-medium text-2xl xs:text-3xl xs:text-[32px] md:text-4xl lg:text-5xl lg:text-[40px]"
          >
            {{ location.activity }}
          </h3>

          <p
            class="text-primary-800 text-lg xs:text-xl md:text-2xl"
          >
            {{ location.start_time }} - {{ location.end_time }}
          </p>

          <div class="flex flex-col gap-1 items-center">
            <address
              class="not-italic text-primary-900 text-pretty text-lg xs:text-xl md:text-2xl"
            >
              {{ location.venue }}
            </address>
            <address
              class="not-italic text-primary-800 text-xs text-balance max-w-xs md:max-w-sm md:text-sm"
            >
              {{ location.address }}
            </address>
          </div>
        </div>

        <UButton
          label="Arahkan ke Lokasi"
          trailing-icon="i-heroicons-arrow-up-right"
          class="rounded-full mx-auto"
          target="_blank"
          rel="noopener noreferrer"
          :href="location.maps_link"
        />
      </li>
    </ul>
  </div>
</template>
